import { render, staticRenderFns } from "./TabInstallation.vue?vue&type=template&id=0b43c0d6&"
import script from "./TabInstallation.vue?vue&type=script&lang=js&"
export * from "./TabInstallation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports